"use strict";

exports.__esModule = true;
exports.TimeWrapper = exports.MutedText = exports.DurationWrapper = exports.CycleListItemColor = exports.CycleListItemButtonHeader = exports.CycleListItemButtonBody = exports.CycleListItemButton = exports.CycleListItemBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = require("../../Core/Text");
var _Theme = require("../../Theme");
var _PlantStateActivities = require("../../PlantStateActivities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// eslint-disable-next-line

var CycleListItemButton = exports.CycleListItemButton = _styledComponents["default"].button.withConfig({
  displayName: "CycleListStylinglegacy__CycleListItemButton",
  componentId: "sc-9h2yux-0"
})(["outline:none;cursor:pointer;box-sizing:border-box;text-align:left;border-style:none;border-bottom:white solid 1px;padding:0;border-right:", " solid 1px;color:", ";background:", ";display:flex;"], (0, _Theme.selectable)("CycleListItemBorderColor"), (0, _Theme.selectable)("CycleListItemColor"), (0, _Theme.selectable)("CycleListItemBackground"));
var CycleListItemColor = exports.CycleListItemColor = _styledComponents["default"].div.withConfig({
  displayName: "CycleListStylinglegacy__CycleListItemColor",
  componentId: "sc-9h2yux-1"
})(["background:", ";border-bottom:1px solid ", ";flex:0 0 10px;height:80px;div{position:relative;top:70%;background:rgba(0,0,0,0.2);height:30%;flex:0 0 10px;border-bottom:1px solid ", ";}"], function (_ref) {
  var state = _ref.state,
    theme = _ref.theme;
  return (0, _PlantStateActivities.getPlantStateColor)(theme, state.id);
}, (0, _Theme.val)("CycleListItemBackground"), (0, _Theme.val)("CycleListItemBackground"));
var CycleListItemBody = exports.CycleListItemBody = _styledComponents["default"].div.withConfig({
  displayName: "CycleListStylinglegacy__CycleListItemBody",
  componentId: "sc-9h2yux-2"
})(["flex:1;height:80px;padding:0.6rem;border-bottom:", " solid 1px;"], (0, _Theme.selectable)("CycleListItemBorderColor"));
var CycleListItemButtonHeader = exports.CycleListItemButtonHeader = (0, _styledComponents["default"])(_core.Text).withConfig({
  displayName: "CycleListStylinglegacy__CycleListItemButtonHeader",
  componentId: "sc-9h2yux-3"
})(["width:100%;font-size:", ";font-weight:", ";margin-bottom:0.3rem;"], (0, _Theme.val)("fontSizeSmall"), (0, _Theme.val)("fontWeightHeavy"));
var TimeWrapper = exports.TimeWrapper = (0, _styledComponents["default"])(_core.Text).withConfig({
  displayName: "CycleListStylinglegacy__TimeWrapper",
  componentId: "sc-9h2yux-4"
})(["width:100%;font-size:", ";margin-bottom:0.3rem;"], (0, _Theme.val)("fontSizeXS"));
var DurationWrapper = exports.DurationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CycleListStylinglegacy__DurationWrapper",
  componentId: "sc-9h2yux-5"
})(["width:100%;font-size:", ";"], (0, _Theme.val)("fontSizeXS"));
var MutedText = exports.MutedText = (0, _styledComponents["default"])(_Text.Text).withConfig({
  displayName: "CycleListStylinglegacy__MutedText",
  componentId: "sc-9h2yux-6"
})(["color:", ";"], (0, _Theme.val)("mutedColor"));
var CycleListItemButtonBody = exports.CycleListItemButtonBody = _styledComponents["default"].div.withConfig({
  displayName: "CycleListStylinglegacy__CycleListItemButtonBody",
  componentId: "sc-9h2yux-7"
})([""]);